// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturesSection_container__6bbLt","title":"FeaturesSection_title__ny6ii","cards":"FeaturesSection_cards__ObFAd","cta":"FeaturesSection_cta__rFXYo"};